import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CorporateFacilityDifferentialRatesDto {
  facilityId: string;
  facilityName: string;
  city: string;
  state: string;
  differentialRates: FacilityDifferentialRateItemDto[];
}

export interface FacilityDifferentialRateItemDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  differentialRate: number;
}
